import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { useEmployeeSelfService } from '../../../contexts/EmployeeSelfServiceContext';

const EmployeeSidebar = ({ isOpen = true, onClose }) => {
  const location = useLocation();
  const { unreadCount } = useEmployeeSelfService();

  const isActive = (path) => {
    if (path === '/erp/employee-self-service') {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const navigationItems = [
    { path: '/erp/employee-self-service', label: 'Home', icon: 'Home' },
    { path: '/erp/employee-self-service/attendance-dashboard', label: 'Punch & Today', icon: 'Camera' },
    { path: '/erp/employee-self-service/attendance-details', label: 'Attendance History', icon: 'Calendar' },
    { path: '/erp/employee-self-service/leave', label: 'Leave', icon: 'CalendarDays' },
    { path: '/erp/employee-self-service/payslip', label: 'Payslips', icon: 'Wallet' },
    { path: '/erp/employee-self-service/regularization', label: 'Corrections', icon: 'Edit' },
    { path: '/erp/employee-self-service/documents', label: 'Documents', icon: 'FileText' },
    { path: '/erp/employee-self-service/notifications', label: 'Notifications', icon: 'Bell', badge: unreadCount },
    { path: '/erp/employee-self-service/profile', label: 'My Profile', icon: 'User' },
    { path: '/erp/employee-self-service/preferences', label: 'Preferences', icon: 'Settings' },
  ];

  const handleLinkClick = () => {
    if (window.innerWidth < 1024 && onClose) onClose();
  };

  return (
    <aside
      className={`fixed left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-card border-r border-border z-40 transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}
    >
      <div className="p-4 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="User" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground text-sm">Employee Portal</h3>
            <p className="text-xs text-muted-foreground">Self Service</p>
          </div>
        </div>
      </div>

      <nav className="p-4 space-y-1 overflow-y-auto h-[calc(100%-5rem)]">
        {navigationItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={handleLinkClick}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              isActive(item.path)
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <Icon name={item.icon} size={18} />
            <span className="flex-1">{item.label}</span>
            {item.badge > 0 && (
              <span className="bg-red-500 text-white text-xs rounded-full min-w-[20px] h-5 px-1.5 flex items-center justify-center">
                {item.badge > 99 ? '99+' : item.badge}
              </span>
            )}
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default EmployeeSidebar;
